<template>
  <Content @back="$router.push('/home')">
    <template v-slot:nav_left>
      <div class="nav-btn-box" v-if="isInClubSystem">
        <p>评估考核列表</p>
      </div>
      <div class="nav-btn-box" v-else>
        <p>初审考核列表</p>
      </div>
    </template>
    <template v-slot:nav_right>
      <template>
        <!-- <div v-if="'performanceGroup' === activeNav" class="yioks_btn" @click="isAddPerformanceGroup = true;">添加评估指标组</div>
        <div v-if="'phase' === activeNav" class="yioks_btn" @click="isAddPerformancePhase = true;">添加考核阶段</div> -->
      </template>
    </template>

    <template v-slot:content_right>
      <div class="com-wrapper content-inner-wrapper">
        <div class="select_wrap">
          <div class="select_box left"></div>
          <div class="select_box right">
            <input
              type="text"
              v-model="selectVal.stageName"
              class="yioks_input"
              style="width: 160px"
              placeholder="请输入考核阶段名称"
              @keyup.enter="changeQuery(true)"
            />
            <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
          </div>
        </div>
        <div class="list_wrap" v-if="!loading && pageList.length">
          <div class="table">
            <div class="thead">
              <div class="tr">
                <div class="th seq">序号</div>
                <template v-if="isInClubSystem">
                  <div class="th stageName">申报评估考核阶段名称</div>
                  <div class="th jixiaoType">评估对象</div>
                  <div class="th description">评估简介</div>
                </template>
                <template v-else>
                  <div class="th stageName">申报初审考核阶段名称</div>
                  <div class="th jixiaoType">初审对象</div>
                  <div class="th description">初审简介</div>
                </template>
                <div class="th start-time">开始时间</div>
                <div class="th end-time">结束时间</div>
                <template v-if="isInClubSystem">
                  <div class="th stageStartDate">已提交</div>
                  <div class="th stageEndDate">已评估</div>
                </template>
                <template v-else>
                  <div class="th stageStartDate">已/未提交</div>
                  <div class="th stageEndDate">已/未评估</div>
                </template>

                <div class="th action">操作</div>
              </div>
            </div>
            <div class="scrollArea">
              <vue-scroll>
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div
                      class="tr"
                      v-for="(item, index) in pageList"
                      :key="index"
                    >
                      <div class="td seq">
                        <p>{{ index + 1 }}</p>
                      </div>
                      <div class="td stageName">
                        <p :title="item.stageName">{{ item.stageName }}</p>
                      </div>
                      <div class="td jixiaoType">
                        <p :title="item.jixiaoType | performanceTypeFilter">
                          {{ item.jixiaoType | performanceTypeFilter }}
                        </p>
                      </div>
                      <div class="td description">
                        <p :title="item.description">{{ item.description }}</p>
                      </div>

                      <div class="td start-time">
                        <p>{{ item.stageStartDate | time(false) }}</p>
                      </div>
                      <div class="td end-time">
                        <p>{{ item.stageEndDate | time(false) }}</p>
                      </div>
                      <template v-if="isInClubSystem">
                        <div class="td stageStartDate">
                          <p>
                            {{ item.submitNum }}
                          </p>
                        </div>
                        <div class="td stageEndDate">
                          <p>
                            {{ item.auditNum }}
                          </p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="td stageStartDate">
                          <p>
                            {{ item.submitNum }}&nbsp;/&nbsp;{{
                              item.noSubmitNum
                            }}
                          </p>
                        </div>
                        <div class="td stageEndDate">
                          <p>
                            {{ item.auditNum }}&nbsp;/&nbsp;{{
                              item.noAuditNum
                            }}
                          </p>
                        </div>
                      </template>
                      <div class="td action">
                        <p>
                          <span class="item" @click="handleCheckRow(item)"
                            >开始评估</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty
          v-if="!loading && !pageList.length"
          tips="暂时没有数据"
        ></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page" />
    </template>
  </Content>
</template>

<script>
import storage from "@/utils/storage";
import { performanceTypeFilter } from "@/assets/js/yioksFilters";
import { getAuditStageListForOrg } from "@/api/performance";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  mixins: [mixinAppConfig],
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    "performance-check": () => import("./components/PerformanceCheck"),
  },

  data() {
    return {
      userRole: storage.get("userInfo").userRole,
      isAddPerformanceGroup: false,
      isAddPerformancePhase: false,
      total: 0,
      page: 0,
      pageSize: 20,
      loading: false,
      empty: false,

      selectVal: {
        stageName: "",
      },
      pageList: [],
    };
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  filters: {
    performanceTypeFilter,
  },

  created() {
    this.loadPageList();
  },

  methods: {
    toPath(path) {
      this.$router.replace({
        path: path,
        query: {
          // navName: navName
        },
      });
    },

    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          size: this.pageSize,
          stageName : this.selectVal.stageName
        },
      });
      this.loadPageList();
    },

    loadPageList() {
      const { page, stageName} = this.$route.query;
      const paramsData = {
        page: page,
        size: this.pageSize,
        stageName : stageName
      };
      this.loading = true;
      getAuditStageListForOrg(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { content, totalElements } = res;
          this.total = totalElements;
          this.pageList = content;
        })
        .catch((err) => {
          this.loading = false;
          console.error("err", err);
        });
    },

    // 操作
    handleCheckRow(row) {
      const { groupUuid, open, uuid: stageUuid, jixiaoType } = row;
      this.$router.push({
        path: "orgCheckUndo",
        query: {
          groupUuid: groupUuid,
          stageUuid: stageUuid,
          activeNav: jixiaoType,
          canEdit: open ? 1 : 2,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        padding 3px 0px
        text-align center
        line-height 1.4em
        color $color_white
        white-space pre-line
.seq
  width 5%
.stageName
  width 20%
.jixiaoType
  width 9%
.description
  width 18%
.start-time
  width 11%
.end-time
  width 11%
.stageStartDate
  width 9%
.stageEndDate
  width 9%
.action
  // width 8%
  flex 1
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  input
    border-radius 0px !important
</style>
